/* Hide only the legacy Pop Convert announcement, not its signup/popups.
 * Scoped to the theme containing this asset. The app and live theme are untouched.
 */
(() => {
  const styleId = 'ws-suppress-legacy-announcement';
  let timer;
  let timeout;
  const observer = new MutationObserver(apply);

  function apply() {
    const root = document.querySelector('#pop-convert-app')?.shadowRoot;
    if (!root) return;
    if (!root.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = '#pc-bar-container{display:none!important;}';
      root.appendChild(style);
    }
    clearInterval(timer);
    clearTimeout(timeout);
    observer.disconnect();
  }

  observer.observe(document.documentElement, { childList: true, subtree: true });
  timer = setInterval(apply, 250);
  timeout = setTimeout(() => {
    clearInterval(timer);
    observer.disconnect();
  }, 30000);
  apply();
})();
